import { render, staticRenderFns } from "./ViberCampaignEditRoute.vue?vue&type=template&id=214f5312&scoped=true&"
import script from "./ViberCampaignEditRoute.vue?vue&type=script&lang=js&"
export * from "./ViberCampaignEditRoute.vue?vue&type=script&lang=js&"
import style0 from "./ViberCampaignEditRoute.vue?vue&type=style&index=0&id=214f5312&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214f5312",
  null
  
)

export default component.exports